<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="vol-1-dedication">
<div class="text" id="vol-1-dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">TO</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">WILLIAM HOGGATT, R. I.,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">AND HIS WIFE</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">DAZINE</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">IN GRATITUDE FOR THEIR FRIENDSHIP</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">AND GENIUS</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol-001-dedication.vue?393786f3